export interface PasswordValidationResult {
  length: boolean;
  lowercase: boolean;
  uppercase: boolean;
  number: boolean;
  specialChar: boolean;
}

export const identifyPasswordValidationResult: PasswordValidationResult = {
  length: false,
  lowercase: false,
  uppercase: false,
  number: false,
  specialChar: false,
};

export const validatePassword = (password: string): PasswordValidationResult => {
  const result: PasswordValidationResult = {
    length: password.length >= 8,
    lowercase: /[a-z]/.test(password),
    uppercase: /[A-Z]/.test(password),
    number: /[0-9]/.test(password),
    specialChar: /[~!@#%^&*()_+=]/.test(password),
  };

  return result;
};
